<template>
  <div>
    <div
      class="mb-2"
    >
      <h3
        class="mb-2"
      >
        Master Creative Properties
      </h3>
      <p
        class="mb-0"
      >
        <small>
          Creative properties set here will apply to all articles and templates.
        </small>
      </p>
    </div>
    <section>
      <h4
        class="mb-3"
      >
        Logo
      </h4>
      <logo-upload
        logo-type="master"
        :key="selectedCreativeId"
      />
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

import LogoUpload from '@/modules/content/components/CreativesPage/Sidebar/LogoUpload';

export default {
  name: 'MasterCreativeProperties',
  components: {
    LogoUpload,
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'selectedCreativeId',
    ]),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.GET_CAMPAIGN_PROPERTIES,
    ]),
  },
  mounted() {
    const { advertiserId, campaignId } = this.$route.params;
    const payload = {
      advertiserId: advertiserId ?? this.campaign.advertiserId,
      campaignId: campaignId ?? this.campaign.id,
      type: this.type,
    };
    this.GET_CAMPAIGN_PROPERTIES(payload);
  },
};
</script>
